import React, { useState } from 'react';

import {useTranslation} from "react-i18next";
import {Col, Row} from "reactstrap";
import Login from "../../pages/auth/Login";
import {ConsultaHelper} from "../../../../shared/helpers";
import VisualizadorPdfV2 from './VisualizadorPdfV2';
import { faFileImage, faFileVideo, faFileWord, faFilePowerpoint, faFileExcel, faFileAudio, faFilePdf, faFileArchive} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MediaView from './MediaView';

const extensoes = [
    { extensao: '.avi', icone: faFileVideo},
    { extensao: '.bmp', icone: faFileImage },
    { extensao: '.doc', icone: faFileWord },
    { extensao: '.docx', icone: faFileWord },
    { extensao: '.ppt', icone: faFilePowerpoint },
    { extensao: '.pptx', icone: faFilePowerpoint },
    { extensao: '.xls', icone: faFileExcel },
    { extensao: '.xlsx', icone: faFileExcel},
    { extensao: '.png', icone: faFileImage },
    { extensao: '.jpg', icone: faFileImage },
    { extensao: '.jpeg', icone: faFileImage },
    { extensao: '.mpeg', icone: faFileVideo },
    { extensao: '.mp3', icone: faFileAudio },
    { extensao: '.mp4', icone: faFileVideo },
    { extensao: '.pdf', icone: faFilePdf },
    { extensao: '.wma', icone: faFileAudio },
    { extensao: '.wmv', icone: faFileVideo },
    { extensao: '.wmv', icone: faFileVideo },
    { extensao: '.zip', icone: faFileArchive },
];

/**
 *
 * @param vinculo
 * @param iconeDefault
 * @returns {JSX.Element}
 */
export const getIcone = (vinculo, iconeDefault, iconClass='s23') => {
    let icone = iconeDefault;
    // Procura a extensao do arquivo primeiro na url, se não achar procura na descricao
    if (vinculo.url_link) {
        extensoes.forEach(e => {
            if (vinculo.url_link.includes(e.extensao)) icone = e.icone;
        });
    }
    if (icone === iconeDefault && vinculo.descricao) {
        extensoes.forEach(e => {
            if (vinculo.descricao.includes(e.extensao))
                icone = e.icone;
        });
    }
    return <FontAwesomeIcon icon={icone} className={iconClass} />;
};

const ModalVinculosPaginaDireita = props => {
    const { t } = useTranslation();
    const [isOpenViewPdfRestrictedOnce, setIsOpenViewPdfRestrictedOnce] = useState(null)
    const [isOpenMediaViewOnLogin, setIsOpenMediaViewOnLogin] = useState(undefined)


    const verifyOpen = (seqParagrafo) => {
        if(isOpenMediaViewOnLogin){
            const {seq_paragrafo} = isOpenMediaViewOnLogin;
            if(seqParagrafo === seq_paragrafo){
              return true;
            }
        }
        return false;
    }

    return (
        <Row>
            <Col md="12" xs="12">
                {props.acervo.links.map(link => (
                    <Row
                        className="pt-3 pb-3 b-solid-bottom b-w1 b-cinza2"
                        key={`link-${link.seq_paragrafo}`}
                    >
                        <Col md="9" xs="8">
                            {link.tipo_link === 'AR' ? (
                                <FontAwesomeIcon
                                    icon="lock"
                                    className="s23 preto70"
                                />
                            ) : link.tipo_link === 'AC' ? (
                                <FontAwesomeIcon
                                    icon="universal-access"
                                    className="azul s35"
                                />
                            ) : (
                                <span className="verde">
                                    {getIcone(link, 'link')}
                                </span>
                            )}
                            <span className="preto70 s14 ml-3">
                                {link.descricao}
                            </span>
                        </Col>
                        <Col md="3" xs="12" className="text-center">
                            {console.log(link)}
                            <div className="d-md-none d-block pad5 t10 b-w1 b-dotted-top b-cinza2" />
                            {link.tipo_link === 'AR' ? (
                                <>
                                    <Login
                                        modal
                                        openModalRender={() => (
                                            <span className="hover1 azul link s13">
                                            {t('AcessarMaterial')} -{' '}
                                                {t('AcessoRestrito')}
                                        </span>
                                        )}
                                        altRender={auth =>{
                                            if(auth){
                                                if(link.is_pdf){
                                                    const { usa_visualizador_php } = props.instituicaoRx;
                                                    if((usa_visualizador_php && usa_visualizador_php === '1') && link.download_pdf === 'N'){
                                                        return (
                                                            <span className="s13">
                                                                <VisualizadorPdfV2
                                                                    codAcervo={props.acervo.cod_acervo}
                                                                    seqParagrafo={link.seq_paragrafo}
                                                                    isRestricted
                                                                />
                                                                <span className="ml-1">{t('AcessarMaterial')} -{' '}{t('AcessoRestrito')}</span>
                                                            </span>
                                                        )
                                                    }
                                                }else if(link.is_media) {
                                                    return (
                                                        <span className="s13">
                                                        <MediaView
                                                            open={verifyOpen(link.seq_paragrafo)}
                                                            isRestricted
                                                            codAcervo={props.acervo.cod_acervo}
                                                            seqParagrafo={link.seq_paragrafo}
                                                            title={link.descricao}
                                                            format={link.media_format}
                                                        />
                                                        <span className="ml-1">{t('AcessarMaterial')}</span>
                                                    </span>
                                                    );
                                                }

                                                return (<span
                                                    className="hover1 azul link s13"
                                                    onClick={() =>
                                                        ConsultaHelper.acessarLinkAcessoRestrito(
                                                            props.acervo.cod_acervo,
                                                            link.seq_paragrafo,
                                                        )
                                                    }
                                                >
                                                    {t('AcessarMaterial')} -{' '}
                                                    {t('AcessoRestrito')}
                                                </span>)
                                            }
                                        }}
                                        loginCallback={() => {
                                            if(link.is_pdf){
                                                const {usa_visualizador_php} = props.instituicaoRx;
                                                if((usa_visualizador_php && usa_visualizador_php === '1') && link.download_pdf === 'N'){
                                                    setIsOpenViewPdfRestrictedOnce({ seqParagrafo: link.seq_paragrafo})
                                                    return;
                                                }
                                            }else if(link.is_media){
                                                setIsOpenMediaViewOnLogin({
                                                    seq_paragrafo: link.seq_paragrafo
                                                })
                                                return;
                                            }

                                            ConsultaHelper.acessarLinkAcessoRestrito(
                                                props.acervo.cod_acervo,
                                                link.seq_paragrafo,
                                            )
                                        }}
                                    />

                                    {
                                        isOpenViewPdfRestrictedOnce !== null && isOpenViewPdfRestrictedOnce?.seqParagrafo === link.seq_paragrafo  ? (
                                            <VisualizadorPdfV2
                                                codAcervo={props.acervo.cod_acervo}
                                                seqParagrafo={link.seq_paragrafo}
                                                isRestrictedOnce
                                                isOpen
                                                setIsOpenViewPdfRestrictedOnce={setIsOpenViewPdfRestrictedOnce}
                                            />
                                        ) : ''
                                    }
                                </>
                            ) : link.tipo_link === 'AC' ? (
                                <>
                                    <Login
                                        modal
                                        openModalRender={() => (
                                            <span className="hover1 azul link s13">
                                            {t('AcessarMaterial')} -{' '}
                                                {t('Acessibilidade')}
                                        </span>
                                        )}
                                        altRender={auth => {
                                            if(auth){
                                                if(link.is_pdf){
                                                    const {usa_visualizador_php} = props.instituicaoRx

                                                    if((usa_visualizador_php && usa_visualizador_php === '1') || link.download_pdf === 'N'){
                                                        return (<span className="s13">
                                                                   <VisualizadorPdfV2
                                                                       codAcervo={props.acervo.cod_acervo}
                                                                       seqParagrafo={link.seq_paragrafo}
                                                                       isRestricted
                                                                   />
                                                                   <span className="ml-1">{t('AcessarMaterial')} -{' '}{t('Acessibilidade')}</span>
                                                                </span>
                                                        )
                                                    }
                                                }else if(link.is_media){
                                                    return (
                                                        <span className="s13">
                                                            <MediaView
                                                                open={verifyOpen(link.seq_paragrafo)}
                                                                title={link.descricao}
                                                                uri={link.url_link}
                                                                format={link.media_format}
                                                                isRestricted
                                                                codAcervo={props.acervo.cod_acervo}
                                                                seqParagrafo={link.seq_paragrafo}
                                                            />
                                                            <span className="ml-1">{t('AcessarMaterial')}</span>
                                                        </span>
                                                    )
                                                }

                                                return (
                                                    <span
                                                        className="hover1 azul link s13"
                                                        onClick={() =>
                                                            ConsultaHelper.acessarLinkAcessoRestrito(
                                                                props.acervo.cod_acervo,
                                                                link.seq_paragrafo,
                                                            )
                                                        }
                                                    >
                                                    {t('AcessarMaterial')} -{' '}
                                                        {t('Acessibilidade')}
                                                </span>
                                                )
                                            }
                                        }}
                                        loginCallback={() => {
                                            if(link.is_pdf){
                                                const {usa_visualizador_php} = props.instituicaoRx;
                                                if((usa_visualizador_php && usa_visualizador_php === '1') || link.download_pdf === 'N') {
                                                    setIsOpenViewPdfRestrictedOnce({ seqParagrafo: link.seq_paragrafo})
                                                    return;
                                                }
                                            }else if(link.is_media){
                                                setIsOpenMediaViewOnLogin({
                                                    seq_paragrafo: link.seq_paragrafo
                                                })
                                                return;
                                            }

                                            ConsultaHelper.acessarLinkAcessoRestrito(
                                                props.acervo.cod_acervo,
                                                link.seq_paragrafo,
                                            )
                                        }}
                                    />
                                    {
                                        isOpenViewPdfRestrictedOnce !== null && isOpenViewPdfRestrictedOnce?.seqParagrafo === link.seq_paragrafo  ? (
                                            <VisualizadorPdfV2
                                                codAcervo={props.acervo.cod_acervo}
                                                seqParagrafo={link.seq_paragrafo}
                                                isRestrictedOnce
                                                isOpen
                                                setIsOpenViewPdfRestrictedOnce={setIsOpenViewPdfRestrictedOnce}
                                            />
                                        ) : ''
                                    }
                                </>
                            ) : (
                                link.is_pdf && ((props.instituicaoRx.usa_visualizador_php && props.instituicaoRx.usa_visualizador_php === '1') || link.download_pdf === 'N') ? (
                                    <span className="s13">
                                       <VisualizadorPdfV2
                                           codAcervo={props.acervo.cod_acervo}
                                           seqParagrafo={link.seq_paragrafo}
                                           urlPdf={link.url_link.toLowerCase() === 'vínculo no banco' ? null : link.url_link}
                                           pdfFromServer={link.url_link.toLowerCase() === 'vínculo no banco'}
                                           descricao={link.descricao}
                                       />
                                        <span className="ml-1">{t('AcessarMaterial')}</span>
                                    </span>
                                ) : link.is_media ? (
                                    <span className="s13">
                                        <MediaView
                                            title={link.descricao}
                                            uri={link.url_link}
                                            format={link.media_format}
                                        />
                                        <span className="ml-1">{t('AcessarMaterial')}</span>
                                    </span>
                            ) : (
                                <span
                                onClick={() =>
                                ConsultaHelper.acessarVinculo(
                                props.acervo.cod_acervo,
                                link.seq_paragrafo,
                                link.url_link.toLowerCase() ===
                                'vínculo no banco'
                                ? `/vinculos/publico/${props.acervo.cod_acervo}/seq/${link.seq_paragrafo}/${link.descricao}`
                                : link.url_link,
                                )
                            }
                                        className="hover1 link azul s13"
                                    >
                                        {t('AcessarMaterial')}
                                    </span>
                                )
                            )}
                        </Col>
                    </Row>
                ))}
            </Col>
        </Row>
    );
};


export default ModalVinculosPaginaDireita;
